import React from 'lib/react';
import { EVIconButton } from 'lib/components';
import { Link } from 'lib/router';
import {
  DASHBOARD_ROUTE,
} from 'constants/RouteConstants';
import { isAuthorized } from 'utils/auth.utils';
import { EV_IMAGE_FILES_PATH } from 'constants/AppConstants';
import HeaderStyles from '../HeaderStyles';

function EVLogoButton() {
  const classes = HeaderStyles();

  const logoImage = <img src={`${EV_IMAGE_FILES_PATH}/EagleViewLogoWithText.svg`} alt="EV Logo" style={{ width: '236px', height: '30px' }} />;

  if (!isAuthorized()) return logoImage;

  return (
    <EVIconButton
      id="ev-logo"
      component={Link}
      to={DASHBOARD_ROUTE}
      className={classes.logoBtn}
    >
      {logoImage}
    </EVIconButton>
  );
}
export default EVLogoButton;
